module.exports = __webpack_public_path__ + "waste-ico.png?e50e096e221424a70d16e4e0f5f30d91";